"use client";

import React, { useState } from "react";
import { Box, Link, Typography, styled } from "@mui/material";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import LinkIcon from "@mui/icons-material/Link";
import {
  SectionHeader,
  SectionContent,
  RightColumn,
} from "./styles/SharedStyles";
import EditButton from "@components/shared/EditButton";
import EditPortfolio from "../modals/EditPortfolio";
import getPortfolioUrl from "@lib/candidates/getPortfolioUrl";
import { cloudinaryTransform, PORTFOLIO_EDIT_THUMB_TRANSFORM } from "@lib/cloudinary";

const PortfolioItem = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  fontSize: 14,
}));

const Portfolio = ({ candidate, onUpdate }) => {
  const [openEdit, setOpenEdit] = useState(false);

  const items = candidate.portfolio || [];

  return (
    <Box>
      <SectionContent>
        <EditButton onEdit={() => setOpenEdit(true)} sx={{ top: 0, right: 0 }} />
        <Box>
          <RightColumn>
            <SectionHeader>
              <Typography variant="h2">Portfolio</Typography>
            </SectionHeader>
            {items.length === 0 && (
              <Typography variant="body2" color="text.secondary">
                No portfolio links added yet.
              </Typography>
            )}
            {items.map((item) => (
              <PortfolioItem key={item.id}>
                {item.type === "image" ? (
                  <Link href={item.url} target="_blank" rel="noopener noreferrer">
                    <Box
                      component="img"
                      src={cloudinaryTransform(item.url, PORTFOLIO_EDIT_THUMB_TRANSFORM)}
                      alt={item.title || "Portfolio image"}
                      sx={{
                        width: 36,
                        height: 36,
                        objectFit: "cover",
                        borderRadius: 1,
                      }}
                    />
                  </Link>
                ) : item.type === "file" ? (
                  <InsertDriveFileOutlinedIcon fontSize="small" color="action" />
                ) : (
                  <LinkIcon fontSize="small" color="action" />
                )}
                <Link
                  href={item.type === "image" ? item.url : getPortfolioUrl(item)}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ fontSize: 14 }}
                >
                  {item.title}
                </Link>
              </PortfolioItem>
            ))}
          </RightColumn>
        </Box>
      </SectionContent>
      <EditPortfolio
        open={openEdit}
        onClose={() => setOpenEdit(false)}
        candidate={candidate}
        onUpdate={onUpdate}
      />
    </Box>
  );
};

export default Portfolio;
